import React from 'react';
import { Typography } from '@mui/material';

export type ILabelProps = {
  label: string | React.ReactNode;
  required?: boolean;
};

export const FormLabel: React.FC<ILabelProps> = ({
  label,
  required = true,
}) => {
  return (
    <Typography variant="body1" fontWeight={600}>
      {label}

      {required && (
        <Typography
          component="span"
          sx={{ color: 'error.main' }}
          ml={0.5}
          fontWeight={600}
        >
          *
        </Typography>
      )}
    </Typography>
  );
};
